import scraperApi from "api";

import { addRedirectActionData } from "hooks/useRedirectFromActionData";
import { addToasterActionData } from "hooks/useToasterFromActionData";

import IRouterActionError from "routes/dataroutes/IRouterActionError";

import { ApiKey } from "types/api-keys/ApiKey";

import { formDataToStructuredObject } from "utils/formDataUtils";


export const path = "/api-keys-data";

export type ApiKeysResponseType = { apiKeys: ApiKey[] };

export async function loader({ request }: { request: Request }): Promise<ApiKeysResponseType> {
  const apiKeys = await scraperApi.apiKeys.fetchApiKeys({ signal: request.signal });
  return { apiKeys };
}

export async function action({ request }: { request: Request }): Promise<ApiKeysResponseType | IRouterActionError | undefined> {
  const formData = formDataToStructuredObject(await request.formData());

  let actionResult;

  if (formData[ApiKeysInputName.action] === ApiKeyActions.new_api_key.value) {
    try {
      const response = await scraperApi.apiKeys.newApiKey({ signal: request.signal });
      actionResult = addToasterActionData({ apiKeys: response }, {
        toastId: "new-api-key-success",
        type: "success",
        title: "New API Key successfully created",
        description: "New API key has been added successfully."
      });
    } catch (err: any) {
      const errorMessage = err.message || "Failed to create API key, please try again later.";

      actionResult = addToasterActionData({
        error: {
          message: errorMessage
        }
      }, {
        toastId: "new-api-key-error",
        type: "error",
        title: "Failed to create API key",
        description: errorMessage
      });
    }
  }

  if (formData[ApiKeysInputName.delete_api_key]) {
    try {
      const response = await scraperApi.apiKeys.removeApiKey(formData[ApiKeysInputName.delete_api_key], { signal: request.signal });
      actionResult = addToasterActionData({ apiKeys: response }, {
        toastId: "delete-api-key-success",
        type: "success",
        title: "API Key successfully deleted",
        description: "API key has been removed successfully."
      });
    } catch (err: any) {
      const errorMessage = err.message || "Failed to delete the API key, please try again later.";
      actionResult = addToasterActionData({
        error: {
          message: errorMessage
        }
      }, {
        toastId: "delete-api-key-error",
        type: "error",
        title: "Failed to delete the API key",
        description: errorMessage
      });
    }
  }

  if (actionResult) {
    if (formData[ApiKeysInputName.redirect]) {
      return addRedirectActionData(actionResult, { to: formData[ApiKeysInputName.redirect], options: { viewTransition: true } });
    } else {
      return actionResult;
    }
  }
}

export const ApiKeysInputName = {
  action: "api-keys-form-action",
  delete_api_key: "delete-api-key",
  redirect: "api-key-action-redirect"
};

function apiKeysFormAction(actionValue: string) {
  return {
    name: ApiKeysInputName.action,
    value: actionValue
  };
}

export const ApiKeyActions = {
  new_api_key: apiKeysFormAction("new-api-key")
};
